const AuthenticationSkeleton = () => {
  return (
    <div className="min-h-screen bg-transparent">
    </div>
  );
};

export default AuthenticationSkeleton;